import request from '@/utils/request'
// 获取字典类型列表
export function listType(data){
    return request({
      url: '/system/dict/type/list',
      method: 'post',
      data
    })
  }
//查询详情
  export function getType(id){
    return request({
      url: '/system/dict/type/'+id,
      method: 'get',
    })
  }

  // 删除字典类型
  export function delType(dictId) {
    return request({
      url: '/system/dict/type/' + dictId,
      method: 'delete'
    })
  }

  // 新增字典类型
export function addType(data) {
    return request({
      url: '/system/dict/type',
      method: 'post',
      data: data
    })
  }

  // 修改字典类型
export function updateType(data) {
    return request({
      url: '/system/dict/type',
      method: 'put',
      data: data
    })
  }


  
// 刷新字典缓存
export function refreshCache() {
    return request({
      url: '/system/dict/type/refreshCache',
      method: 'delete'
    })
  }
  
  // 获取字典选择框列表
  export function optionselect() {
    return request({
      url: '/system/dict/type/optionselect',
      method: 'get'
    })
  }


  // 查询字典数据列表
export function listData(data) {
    return request({
      url: '/system/dict/data/list',
      method: 'post',
      data
    })
  }
  
  // 查询字典数据详细
  export function getData(id) {
    return request({
      url: '/system/dict/data/' + id,
      method: 'get'
    })
  }
  
  // 根据字典类型查询字典数据信息
  export function getDicts(dictType) {
    return request({
      url: '/system/dict/data/type/' + dictType,
      method: 'get'
    })
  }
  
  // 新增字典数据
  export function addData(data) {
    return request({
      url: '/system/dict/data',
      method: 'post',
      data: data
    })
  }
  
  // 修改字典数据
  export function updateData(data) {
    return request({
      url: '/system/dict/data',
      method: 'put',
      data: data
    })
  }
  
  // 删除字典数据
  export function delData(id) {
    return request({
      url: '/system/dict/data/' + id,
      method: 'delete'
    })
  }
  

